import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Flex, Loading, Text } from "@paguelofacil/pf-components";

import { ManageService } from "../services/Services";
import { language, languageDefault } from "../services/utils/Language";
import useStore from "../services/store/useStore";

import { ButtonBack } from "./ButtonBack";
import { InputAmountExpand } from "./Inputs/AmountExpand";

const PaymentAmount = ({ handle, handleBack, hasBalance = true, maxAmount, showSteps = true }) => {
    const { setCurrencySelected, setNetworkSelected } = useStore(state => state);
    const [amount, setAmount] = useState("");
    const [userBalance, setUserBalance] = useState(null);

    const handleSubmit = event => {
        event.preventDefault();
        handle(amount);
    };

    useEffect(() => {
        if (hasBalance) {
            ManageService.apiGetBalance().then(response => {
                if (response) {
                    console.log("response", response);
                    setUserBalance(response);
                }
            });
        }
    }, [hasBalance]);

    useEffect(() => {
        setCurrencySelected(null);
        setNetworkSelected(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Loading isLoading={hasBalance ? !userBalance : false}>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                <Flex direction="column" gap="2rem">
                    <Flex direction="row" wrap="nowrap" align="center" justify="space-between">
                        <Flex gap="0" width="auto" minW="auto">
                            <ButtonBack handleBack={handleBack} />
                            <Text variant="caption" weight="regular" style={{ maxWidth: "450px" }}>
                                <FormattedMessage
                                    id={language.enter_amount}
                                    defaultMessage={languageDefault.enter_amount}
                                />
                            </Text>
                        </Flex>
                        {showSteps ? (
                            <Text variant="caption" weight="regular" style={{ maxWidth: "450px" }}>
                                1/3
                            </Text>
                        ) : (
                            <></>
                        )}
                    </Flex>
                    <Flex direction="column" gap="0" align="center" justify="center">
                        <InputAmountExpand
                            onChangeValue={setAmount}
                            maxAmount={hasBalance ? userBalance || 0 : maxAmount || null}
                        />
                        {hasBalance ? (
                            <Text variant="caption" weight="regular" color="#3D444F">
                                <FormattedMessage
                                    id={language.balanace_available}
                                    defaultMessage={languageDefault.balanace_available}
                                />
                                : $ {userBalance || 0}
                            </Text>
                        ) : (
                            <Text variant="caption" weight="regular" color="#3D444F">
                                <FormattedMessage
                                    id={language.disclaimer_amount_tax}
                                    defaultMessage={languageDefault.disclaimer_amount_tax}
                                />
                            </Text>
                        )}
                    </Flex>
                    <Button
                        className="button-primary-cf"
                        disabled={hasBalance ? !amount || !userBalance : !amount}
                        size="md"
                        type="submit"
                        fullWidth
                    >
                        <FormattedMessage id={language.next} defaultMessage={languageDefault.next} />
                    </Button>
                    <Text variant="caption" weight="regular" style={{ maxWidth: "46rem" }}>
                        <FormattedMessage
                            id={language.first_term_conditions}
                            defaultMessage={languageDefault.first_term_conditions}
                        />
                        &nbsp;
                        <a href="http://www.paguelofacil.com/terminos-y-condiciones/" target="_blank" rel="noreferrer">
                            <FormattedMessage
                                id={language.term_conditions}
                                defaultMessage={languageDefault.term_conditions}
                            />
                        </a>
                        &nbsp;
                        <FormattedMessage
                            id={language.second_term_conditions}
                            defaultMessage={languageDefault.second_term_conditions}
                        />
                    </Text>
                </Flex>
            </form>
        </Loading>
    );
};

export default PaymentAmount;
